import React from 'react';

import Hero from '@components/Hero/Hero';

import {
  CompanyPageHeroContentDIV,
  CompanyPageHeroDIV,
} from './CompanyPageHero.styles';

const CompanyPageHero = ({
  title,
  subtitle,
}) => (
    <Hero>
      <CompanyPageHeroDIV>
        <div className="container">
          <CompanyPageHeroContentDIV>
            <h1 className="font--display-M">{title || `Policies and Procedures`}</h1>
            <p>{subtitle || `We’re committed to keeping your data secure, your private information private, and being transparent about our practices as a business.`}</p>
          </CompanyPageHeroContentDIV>
        </div>
      </CompanyPageHeroDIV>
    </Hero>
  );

export default CompanyPageHero;
